import { render, staticRenderFns } from "./DictItemTexts.vue?vue&type=template&id=780be0f2&scoped=true"
import script from "./DictItemTexts.vue?vue&type=script&lang=js"
export * from "./DictItemTexts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780be0f2",
  null
  
)

export default component.exports